import { fetcherCMS } from '@/modules/api';
import { getCMSImageFieldsUrl, getCMSLocale } from '@/modules/cms';
import { type CMSApiBase, type CMSImageBase, createCmsUrl } from './base';
import type { CMSFaq, CMSSteps, CMSTextContent } from './restrictions';

export interface DiceRollMenuDataApi extends CMSApiBase {
  pageTitle: string;
  menu: {
    bg: CMSImageBase;
    character: CMSImageBase;
    reward: string;
    dailySpins: string;
    tryTomorrow: string;
  };
}

export const getDiceRollMenuCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'dice-roll',
    queryData: {
      ...getCMSLocale(lang),
      populate: {
        menu: {
          populate: {
            ...getCMSImageFieldsUrl('bg'),
            ...getCMSImageFieldsUrl('character'),
          },
        },
      },
      fields: ['page_title'],
    },
  });

export const getDiceRollCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'dice-roll',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const getDiceRollPageTitleCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'dice-roll',
    queryData: {
      ...getCMSLocale(lang),
      fields: ['page_title'],
    },
  });

export const fetchDiceRollMenuCMS = async (lang: string) => {
  const response = await fetcherCMS<DiceRollMenuDataApi>(
    getDiceRollMenuCMSUrl(lang)
  );
  return { data: response };
};

export interface DiceRollApi extends DiceRollMenuDataApi {
  description: CMSTextContent[];
  leftCharacter: CMSImageBase;
  rightCharacter: CMSImageBase;
  mobileCharacter: CMSImageBase;
  leftDecor: CMSImageBase;
  rightDecor: CMSImageBase;
  leftCenterDecor: CMSImageBase;
  rightCenterDecor: CMSImageBase;
  wheelArrow: CMSImageBase;
  topBg: CMSImageBase;
  topBgMobile: CMSImageBase;
  howToParticipate: CMSSteps[];
  faq: CMSFaq[];
  bonusBuyPromocode?: string;
}

export const fetchDiceRollCMS = async (lang: string) => {
  const response = await fetcherCMS<DiceRollApi>(getDiceRollCMSUrl(lang));
  return { data: response };
};

export interface DiceRollPageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const fetchDiceRollPageTitleCMS = async (lang: string) => {
  const response = await fetcherCMS<DiceRollPageTitleApi>(
    getDiceRollPageTitleCMSUrl(lang)
  );
  return { data: response };
};
